import { ajax } from "legacy/ajax";

import $ from "jquery";
import _ from "underscore";

import "vendor/jquery/typeahead";

const CitySearch = {};
let autoGeneratedWhitelist = false;

CitySearch.locationTemplate = _.template("<%= city %>, <%= state %>");

CitySearch.setSubTitle = function(location) {
  $('.city-search-sub-title').text(location ? CitySearch.locationTemplate(location) : '');
};

CitySearch.locationAjaxHandler = function(query, callback) {
  ajax({
    url: "/city_search/search.json?ajax=1",
    data: { query: query },
    success: function(results) {
      // this will set or clear the description based on what is returned from server
      CitySearch.setSubTitle(results['description']);
      // this will set or clear the results based on what is returned from the server
      callback(results['suggestions']);
    },

    error_with_message: function(xhr, message, textStatus) {
      this.show_message(message, true);
    }
  });
};

CitySearch.formTypeaheadSetup = function(inputSelector, typeaheadSelector, whitelistSelector) {
  // TODO: fix default styling to show white background
  $(inputSelector).typeahead(null, {
    name: 'locations',
    displayKey: CitySearch.locationTemplate,
    highlight: true,
    source: CitySearch.locationAjaxHandler,
    templates: {
      suggestion: CitySearch.locationTemplate
    }
  });

  $(typeaheadSelector).blur(function() {
    const input = $(inputSelector).val();

    if (input.length === 3 && !isNaN(input) && ($(whitelistSelector).val().length === 0 || autoGeneratedWhitelist)) {
      $(whitelistSelector).val(input);
      autoGeneratedWhitelist = true;
    } else if (input !== $(whitelistSelector).val() && autoGeneratedWhitelist) {
      $(whitelistSelector).val('');
      autoGeneratedWhitelist = false;
    }
  });

  $(whitelistSelector).keyup(function() {
    if ($(whitelistSelector).val() !== $(inputSelector).val()) {
      autoGeneratedWhitelist = false;
    }
  });
};

export default CitySearch;
